import { FunctionComponent, MutableRefObject, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

import * as T from 'types'

import GoogleMap from './GoogleMap'
import ListingDetails from './ListingDetails'
import ListingProvidedBy from './ListingProvidedBy'

const WALK_SCORE = 'walkScore'
const GREAT_SCHOOLS = 'greatSchools'
const YELP_ACTIVITIES = 'yelpActivities'

const Container = styled.div`
  background: ${props => props.theme.colors.grey2};
  padding-bottom: 20px;
  margin: 0 10px;
`

interface IProps {
  listing: T.IListing
  displayMap?: boolean
}

// General scroll to element function
const scrollToRef = (ref: MutableRefObject<any>) => {
  if (!ref.current || !ref.current.offsetTop) return

  window.scrollTo({
    top: ref.current.offsetTop,
    left: 0,
    behavior: 'smooth',
  })
}

const Sections: FunctionComponent<IProps> = ({ listing, displayMap }) => {
  const walkScoreRef = useRef(null)
  const greatSchoolsRef = useRef(null)
  const yelpActivitiesRef = useRef(null)

  const [initialized, setInitialized] = useState(false)
  const [scrolledToSection] = useState(WALK_SCORE)
  const [scrolling, setScrolling] = useState(false)
  // temporarily disabled
  // const handleScrollToSectionChange = (section: string) => {
  //   setScrolledToSection(section)
  //   setScrolling(true)
  // }

  useEffect(() => {
    if (!initialized) return setInitialized(true)

    if (typeof window === 'undefined') return

    if (scrolledToSection === WALK_SCORE) scrollToRef(walkScoreRef)

    if (scrolledToSection === GREAT_SCHOOLS) scrollToRef(greatSchoolsRef)

    if (scrolledToSection === YELP_ACTIVITIES) scrollToRef(yelpActivitiesRef)

    setScrolling(false)
  }, [scrolling])

  return (
    <Container>
      <ListingDetails listing={listing} />
      <ListingProvidedBy listing={listing} />
      {displayMap && <GoogleMap listing={listing} />}
    </Container>
  )
}

export default Sections
